.privacyContainer {
  background-color: var(--bg-canvas);
  max-width: none;
  padding: var(--spacing-5xl) 0 var(--spacing-2xl);
  b {
    font-weight: bold;
  }
}

.privacyCard {
  max-width: 750px;
  margin: 40px auto;
}

.welcome {
  border-bottom: 1px solid var(--border-default);
  margin-bottom: 24px;
}

.revisedDate {
  font-weight: bold;
  margin-bottom: 20px;
}

.sectionHeading {
  margin-bottom: 15px;
  margin-top: 24px;
}

.sectionNumber {
  padding-right: 10px;
}

.content {
  p {
    margin-bottom: 15px;
  }
}

.bulletList,
.subList {
  li {
    list-style-type: disc;
    list-style-position: inside;
    margin-left: 32px;
  }
}

.subList li {
  list-style-type: circle;
}
